module.exports = __webpack_public_path__ + "img/commuter-pier.ac361db6.webp";